import {graphql} from 'react-relay'

export const testScopesViewQuery = graphql`
  query TestScopesViewQuery($scopeName: String!, $locator: String!) {
    testScopes(scopeName: $scopeName, locator: $locator) {
      ...TestScopesView
    }
  }
`
